import * as Types from '../../constants/actionTypes';

export default (state={}, action)=>{
    switch(action.type){
        case Types.CLIENT_TERMS_SUCCESS:
             return {
                 ...state,
                 termsPrivacyDetail: action.payload
             }
        default : 
            return state   
    }
}
